import { useFeatureFlags } from 'utils/features';

export default function useSafetyTrainingsEnabled() {
  return useFeatureFlags('SAFETY_TRAINING');
}
